import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-sr-view',
  templateUrl: './employee-sr-view.component.html',
  styleUrls: ['./employee-sr-view.component.css']
})
export class EmployeeSrViewComponent implements OnInit {

    title =" Employee SR View ";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/employee-sr-view/employee-sr-view.component.ts